export default function (args: any) {

    const percentValue = Math.round(args.percentValue || 0);

    const styleData = {
        width: percentValue + '%'
    };

    return (<div className="questionnaire-navbar__progress">
        <div className="progress-bar progress-bar_dark">
            <div className="progress-bar-linear
progress-bar-linear_dark">
                <div className="progress-bar-linear__label">Готово:<span>{percentValue}%</span></div>
                <div className="progress-bar-linear__field"><span style={styleData}></span></div>
            </div>
        </div>
    </div>);
}
